import { jsonFetch } from "@/lib/helpers";
import { Booking } from "@/models/booking";
import { BOOKINGS_URL } from "./api-url.constants";
import { BookingDTO } from "./dtos";
import { mapBookingDTOToBooking } from "./mappers";

interface BookingsByRoomIdResponse {
  data: BookingDTO[];
}

export const getBookingsByRoomId = async (
  roomId: string,
  includeAdjacent = false
): Promise<Booking[]> => {
  const endpoint = includeAdjacent
    ? `${BOOKINGS_URL}/room/${roomId}/current-and-adjacent`
    : `${BOOKINGS_URL}/room/${roomId}/current`;

  const response = await jsonFetch<BookingsByRoomIdResponse>(endpoint);
  return response.data.map(mapBookingDTOToBooking);
};
